export class EnrollmentPaymentInfo {

    enrollmentId          : number;
    totalPriceCourses     : number;
    totalPriceExtras      : number;
    discountPercentCourses: number;
    discountPriceCourses  : number;
    discountPercentExtras : number;
    discountPriceExtras   : number;
    finalPriceCourses     : number;
    finalPriceExtras      : number;
    finalPriceEnrollment  : number;

}